import { useCallback, useEffect, useState } from "react";
import type { ModelGradeType } from "../../../../../common-deprecated/types/CommonTypes";
import { getEquipmentFilterQuery, setEquipmentFilterQuery } from "../../utils/navUtils";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../redux/store";
import { hasEquipmentFilter, parseByEquipmentAvailability } from "../../utils/typedUtils";
import { setFilterEquipment } from "../../../../../common-deprecated/redux/actions/UtilActions";
import { useDispatch } from "../../../../../shared-logic/redux/store";

type useEquipmentModelStepFilterReturnType = {
    filteredGrades: ModelGradeType[];
    selectFilterItem: (id: string) => void;
    deselectFilterItem: (id: string) => void;
    itemIsSelected: boolean;
};

const useEquipmentModelStepFilter = (): useEquipmentModelStepFilterReturnType => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const navigation = useBnbSelector((state) => state.navigation);
    const filterItems = useBnbSelector((state) => state.model.filterItems);
    const modelGrades = useBnbSelector((state) => state.model.grades);
    const modelHasEquipmentFilter = useBnbSelector(hasEquipmentFilter);

    const [filteredGrades, setFilteredGrades] = useState<ModelGradeType[]>(modelGrades);
    const [itemIsSelected, setItemIsSelected] = useState<boolean>(false); // Needs to be disabled by default

    useEffect(() => {
        // reset filter in case the original data changes (prep for SPA behaviour)
        setFilteredGrades(modelGrades);
    }, [modelGrades]);

    const filterSelected = useCallback(
        (id: string) => parseByEquipmentAvailability<ModelGradeType>(modelGrades, true, id),
        [modelGrades],
    );
    const filterDeselected = useCallback(
        (id: string) => parseByEquipmentAvailability<ModelGradeType>(modelGrades, false, id),
        [modelGrades],
    );

    const selectFilterItem = (id: string) => {
        setItemIsSelected(true);
        setFilteredGrades(filterSelected(id));
        setEquipmentFilterQuery(navigation, id, true);
        dispatch(setFilterEquipment(`${true.toString()}:${id}`));
    };

    const deselectFilterItem = (id: string) => {
        setItemIsSelected(false);
        setFilteredGrades(filterDeselected(id));
        setEquipmentFilterQuery(navigation, id, false);
        dispatch(setFilterEquipment(`${false.toString()}:${id}`));
    };

    // Preselect items on first Render
    useEffect(() => {
        if (modelHasEquipmentFilter) {
            const { isSelected, equipmentId } = getEquipmentFilterQuery();

            if (equipmentId) {
                if (isSelected) {
                    selectFilterItem(equipmentId);
                } else {
                    deselectFilterItem(equipmentId);
                }
            } else {
                filterItems.forEach((item) => {
                    selectFilterItem(item.id);
                });
            }
        }
    }, []);

    return {
        filteredGrades,
        selectFilterItem,
        deselectFilterItem,
        itemIsSelected,
    };
};

export default useEquipmentModelStepFilter;
